import { memo } from 'react'
import { sanitizeHTML } from 'src/utils/sanitizeHTML'

import './styles.scss'

type MiniPdpProductDescriptionProps = {
  content: string
}

const MiniPdpProductDescription = ({
  content,
}: MiniPdpProductDescriptionProps) => {
  return (
    <article
      data-testid="miniPdpProductDescription"
      className="mini-pdp-product-description productDescription w-full"
    >
      <div
        suppressHydrationWarning
        dangerouslySetInnerHTML={{
          __html: sanitizeHTML(content),
        }}
      />
    </article>
  )
}

export default memo(MiniPdpProductDescription)
